import { ReactNode } from 'react';
import styled from 'styled-components';
import { DisableSelection } from '../../../styles/stylesStyled';

interface ButtonProps {
  negative?: boolean;
  fs?: string;
  darkFont?: string;
  h?: string;
  p?: string;
  condensed?: boolean;
  negativeLight?: boolean;
  textButton?: boolean;
  w?: string;
  wSM?: string;
  maxWidth?: string;
  maxWidthSM?: string;
  m?: string;
  ml?: string;
  mr?: string;
  mt?: string;
  mb?: string;
  mSM?: string;
  mlSM?: string;
  mrSM?: string;
  mtSM?: string;
  mbSM?: string;
  disabled?: boolean;
  children?: ReactNode;
  textColor?: string;
  buttonBackground?: string;
  fontFamily?: string;
}

export const Button = styled.button<ButtonProps>`
  border: none;
  font-size: 15px;
  font-weight: 500;
  color: #fff;
  height: 50px;
  border-radius: 100px;
  width: ${({ w }) => (w ? w : '100%')};
  cursor: pointer;
  font-size: ${(props) => props.theme.buttonFontSize};

  ${(props) => props.fontFamily && `font-family: ${props.fontFamily};`}

  color: ${(props) =>
    props.negative
      ? props.theme.colors.primary900
      : props.theme.colors.neutral0};

  ${(props) => props.textColor && `color: ${props.textColor};`}
  background: ${(props) =>
    props.negative
      ? props.theme.colors.neutral100
      : props.theme.buttonBackground};
  border: ${(props) =>
    props.negative ? `1px solid ${props.theme.colors.primary900}` : `none`};

  ${(props) => props.disabled && `opacity: 0.5;`}
  ${(props) => props.disabled && `cursor: not-allowed`};

  ${(props) => props.fs && `font-size: ${props.fs}`};

  ${({ color }) => color && `background-color: ${color}`};

  height: ${(props) => props.h};
  padding: ${(props) => props.p};

  margin: ${(props) => props.m};
  margin-top: ${(props) => props.mt}px;
  margin-bottom: ${(props) => props.mb}px;
  margin-left: ${(props) => props.ml}px;
  margin-right: ${(props) => props.mr}px;

  max-width: ${(props) => props.maxWidth};

  ${({ condensed }) =>
    condensed &&
    `
    height: 33px; 

  `}

  ${({ negativeLight, theme }) =>
    negativeLight &&
    `
    border: 1px solid ${theme.colors.neutral0};
    color: ${theme.colors.neutral0};
    background: none;

  `}

  @media (max-width: 800px) {
    margin: ${(props) => props.mSM};
    margin-top: ${(props) => props.mtSM}px;
    margin-bottom: ${(props) => props.mbSM}px;
    margin-left: ${(props) => props.mlSM}px;
    margin-right: ${(props) => props.mrSM}px;

    max-width: ${(props) => props.maxWidthSM};
    width: ${(props) => (props.wSM ? props.wSM : '100%')};
  }

  ${({ textButton, theme, textColor }) =>
    textButton &&
    `
    background-color: rgba(0,0,0,0);
    color: ${textColor ? textColor : theme.colors.neutral900};
    border: none;
    text-decoration: underline;

  `}

  transition: transform 0.1s ease, background-color 0.3s ease, border 0.3s ease,
    color 0.3s ease;

  :active {
    transform: translateY(3px);
  }
  > * {
    ${DisableSelection}
  }
`;
